var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    [
      _c("popup", {
        staticClass: "bg-gray",
        attrs: {
          opened: _vm.isAcnoPopupOpen,
          "use-header": true,
          "use-footer": true,
          useTopBorder: false,
          btnAreaPadding: true,
          title: "MPSH-03-01-01-04"
        },
        on: {
          "update:opened": function($event) {
            _vm.isAcnoPopupOpen = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function() {
              return _vm._l(_vm.pushNotiAcnoStupInfo.dataGrid, function(list) {
                return _c(
                  "div",
                  { key: list.i, staticClass: "box-white -type4 setting" },
                  [
                    _c("div", { staticClass: "header" }, [
                      _c("div", { staticClass: "title" }, [
                        _vm._v(_vm._s(list.acnoAls))
                      ]),
                      _c("div", { staticClass: "desc" }, [
                        _c("div", { staticClass: "item account" }, [
                          _vm._v(
                            _vm._s(list.acno) + " - " + _vm._s(list.acnOtPutNm)
                          )
                        ])
                      ]),
                      _c("div", { staticClass: "form-switch" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: list.cnsntYn,
                              expression: "list.cnsntYn"
                            }
                          ],
                          staticClass: "form-check-input",
                          attrs: {
                            type: "checkbox",
                            "true-value": "1",
                            "false-value": "0"
                          },
                          domProps: {
                            checked: Array.isArray(list.cnsntYn)
                              ? _vm._i(list.cnsntYn, null) > -1
                              : _vm._q(list.cnsntYn, "1")
                          },
                          on: {
                            change: function($event) {
                              var $$a = list.cnsntYn,
                                $$el = $event.target,
                                $$c = $$el.checked ? "1" : "0"
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(list, "cnsntYn", $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      list,
                                      "cnsntYn",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(list, "cnsntYn", $$c)
                              }
                            }
                          }
                        }),
                        _c("span", { staticClass: "slider round" })
                      ])
                    ])
                  ]
                )
              })
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c(
                  "button",
                  {
                    staticClass: "btn md normal",
                    on: {
                      click: function($event) {
                        return _vm.setRcdrwCnsntYn()
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("MPSH-01-01-00-02")) + " ")]
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }